import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonGrid = _resolveComponent("ButtonGrid")!

  return (_openBlock(), _createBlock(_component_ButtonGrid, {
    audioContext: _ctx.audioContext,
    gridSize: _ctx.gridSizes[_ctx.gridSizesIndex],
    level: _ctx.level
  }, null, 8, ["audioContext", "gridSize", "level"]))
}